import {spaceNumber} from '../../../utils/numerals/spaceNumber';
import {trigger} from "../../../utils/events/trigger";
import { updateCriteo } from '../../common/criteo';

const getMinMortgagePayment = (calc) => {
    const payments = Array.from(calc.querySelectorAll(`ul.banks li.program.valid li.payment`))
        .map((li) => parseInt(li.textContent.replace(/\D/g, ``)));
    payments.sort((a, b) => a - b);
    return payments[0];
};

export const updateTooltipData = (tooltip, path, rooms, calc) => {
    const number = path.id.replace(/\D+-/g, ``);
    const room = rooms.find((room) => room.dataset.number === number);
    const button = tooltip.querySelector(`button`);
    const dataNames = JSON.parse(button.getAttribute(`data-names`));
    
    if (calc)
    {
        const calcPriceInput = calc.querySelector(`[name="price"]`);
        const minPayment = getMinMortgagePayment(calc);
		if (minPayment)
		{
			room.dataset.mortgagePayment = `от ${spaceNumber(minPayment)} ₽/мес`;
		}
		else
		{
			room.dataset.mortgagePayment = ``;
		}

        calcPriceInput.value = room.dataset.price.replace(/\D/g, ``);
        trigger(calcPriceInput, `change`); 
    }

    if (room)
    {
        tooltip.querySelector(`span.title`).textContent = `${room.dataset.title} ${room.dataset.number}, ${room.dataset.area}`;
        tooltip.querySelector(`span.price`).textContent = room.dataset.price;

        tooltip.querySelector(`span.mortgage-payment`).textContent = room.dataset.mortgagePayment;

        button.setAttribute(`data-names`, JSON.stringify({
            ...dataNames,
            "parking_storage_id" : room.dataset.number,
            "parking_storage_price": room.dataset.price,
            "parking_storage_mortgage_payment": room.dataset.mortgagePayment ? room.dataset.mortgagePayment : "",       
            "room_id": room.dataset.id,
            "subject": `${dataNames[`subject_part`]} №${room.dataset.number}`,
        }));

		updateCriteo( room.dataset.id, 'viewItem' );
    }
};
